module.exports = __webpack_public_path__ + "static/media/image 13.45891098.png";